import styled, {css} from 'styled-components'
import * as Ariakit from '@ariakit/react'

export const StyledPopover = styled(Ariakit.Popover)(
    ({theme: {palette, shadows, zIndex}}) => css`
        z-index: ${zIndex.dropdown};
        background-color: ${palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${shadows.md};
        outline: 1px solid ${palette.neutral['100']};
    `
)

export const StyledDialog = styled(Ariakit.Dialog)(
    ({theme: {palette, shadows, zIndex}}) => css`
        z-index: ${zIndex.dropdown};
        background-color: ${palette.neutral.white};
        border-radius: 4px;
        box-shadow: ${shadows.md};
    `
)

export const StyledDialogBackdrop = styled.div(
    ({theme: {palette}}) => css`
        background: ${palette.neutral['600']};
        opacity: 0.6;
    `
)
